import {Component, computed, input, output, signal} from '@angular/core';
import {MatIcon} from '@angular/material/icon';

/**
 * Shows one report image from a ready-made URL. Emits `settled` once the
 * browser has either loaded the image or given up, so a report can tell
 * when it is complete enough to print.
 */
@Component({
  selector: 'app-report-image',
  imports: [MatIcon],
  templateUrl: './report-image.component.html',
  styleUrl: './report-image.component.scss',
})
export class ReportImageComponent {
  src = input<string | null>(null);
  alt = input<string>('');
  settled = output<void>();

  private failedSrc = signal<string | null>(null);

  showImage = computed(() => !!this.src() && this.src() !== this.failedSrc());

  onLoad() {
    this.settled.emit();
  }

  onError() {
    this.failedSrc.set(this.src());
    this.settled.emit();
  }
}
